import {
  Box,
  Card,
  CardContent,
  Grid,
  Switch,
  Typography,
  Checkbox,
  Autocomplete,
  TextField,
  Button,
  Icon,
  IconButton,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import { TimePicker } from "@mui/x-date-pickers";
import {
  AddCircleOutlineRounded,
  ContentCopyOutlined,
  RemoveCircleOutlineRounded,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import { IMTImeRoles, mealOptions, dayHoursOptions, weekHoursOptions, findOverlappingSlots, isValidSlot } from "../utils";
import {
  getWorkerIMTimeRole,
} from "services/workerSchedule";
import { EDIT, EMPTY } from '../contants';
import dayjs from 'dayjs';
import _, { update } from 'lodash';
import { updateIMTimeAccess } from '../../../redux/actions/addEditWorker';
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 

const IMTime = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                            ? location.state.approveForManager : {};
  //const {workerDocument, workerRoles={}, workerSchedule={}, loadingRoles} = useSelector(state => state.addEditWorker);
  const workerRoles = useSelector(state => state.addEditWorker.workerRoles);
  const workerSchedule = useSelector(state => state.addEditWorker.workerSchedule);
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const workerDocument = useSelector(state => state.addEditWorker.workerDocument);
  const imtRole = useSelector( state => state.user.imtRole || null)
  let imTimeAccess = _.cloneDeep(workerRoles?.['timeRole'] || {});
  console.log("redux state", workerRoles, workerSchedule);
  const { user } = useSelector((state) => state.user.auth);

  const initialWorkingDays = {
    Sunday: workerSchedule?.Sunday ? true : false,
    Monday: workerSchedule?.Monday ? true : false,
    Tuesday: workerSchedule?.Tuesday ? true : false,
    Wednesday: workerSchedule?.Wednesday ? true : false,
    Thursday: workerSchedule?.Thursday ? true : false,
    Friday: workerSchedule?.Friday ? true : false,
    Saturday: workerSchedule?.Saturday ? true : false
  };

  //Default time slot values
  const startTime = '09:00am';
  const endTime = '05:00pm';  


  const initialFormValues = {
    isActive: imTimeAccess?.isActive || false,
    role: imTimeAccess?.role || EMPTY,
    isScannerOnly: imTimeAccess?.isScannerOnly || false,
    workingHoursEnabled: workerSchedule?.workingHoursEnabled == true ? true : false,
    meal: { 
      enabled: workerSchedule?.meal?.enabled || false, 
      value: workerSchedule?.meal?.value || '30 mins' 
    },
    weekHours: {
      enabled: workerSchedule?.weekHours?.enabled || false,
      value: workerSchedule?.weekHours?.value || '40 Hours'
    },
    dayHours: {
      enabled: workerSchedule?.dayHours?.enabled || false,
      value: workerSchedule?.dayHours?.value || '8 Hours'
    },
  };
  Object.keys(initialWorkingDays).forEach(day => {
    if(workerSchedule?.[day]){
      initialFormValues[day] = workerSchedule[day];
    }
  })

  
//  console.log("initialFormValues", initialFormValues);
  

  const [formValues, setFormValues] = useState(_.cloneDeep(initialFormValues));
  console.log("initial", formValues);
  const [workingDays, setworkingDays] = useState({...initialWorkingDays});
  const [formErrors, setFormErrors] = useState({});
  const [loggedWorkerIMTRole, setLoggedWorkerIMTRole] = useState(null);
  const [roleoptions, setRoleOptions] = useState([...IMTImeRoles]);
  const [disableSave, setDisableSave] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
    const [snackControl, setSnackControl] = useState({
      open: false,
      message: "",
      severity: 'success'
    });

  const prevState = React.useRef();
  useEffect(() => {
    if(initialFormValues && !_.isEqual(prevState.current, initialFormValues)){
      setworkingDays({...initialWorkingDays});
      setFormValues(_.cloneDeep(initialFormValues));
      prevState.current = _.cloneDeep(initialFormValues);
    }
  }, [initialFormValues])

  useEffect(()=>{
    if(user && user.workerId){
    getWorkerIMTimeRole(user?.workerId)
          .then((data) => {
            console.log("loggedIn worker imtRole", data);
            setLoggedWorkerIMTRole(data);
      });
    }
  },[user]); 

  useEffect(() => {
    if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
    }
  },[imtRole])

  useEffect(() => {
    if(!_.isEmpty(loggedWorkerIMTRole)  && !_.isEmpty(workerDocument)){
      let filteredRoles = [...roleoptions];
      if(loggedWorkerIMTRole?.role === "Admin" || loggedWorkerIMTRole?.role === "Super User"){
        if(!filteredRoles.includes("Super User"))
        filteredRoles.unshift("Super User");
      }
      if(loggedWorkerIMTRole?.role === "Admin"){
        if(!filteredRoles.includes("Support"))
        filteredRoles.unshift("Support");
      }
      if(workerDocument && workerDocument?.isManager){
        filteredRoles = filteredRoles.filter(role => role !== "Worker")
      }
       console.log("filteredRoles", filteredRoles);
      setRoleOptions(filteredRoles);
    }
  }, [loggedWorkerIMTRole, workerDocument])


  useEffect(() => {
    validate(formValues);
  }, [formValues]);

  const validate = (values) => {
    const errors = {};
    if (values.isActive) {
      if (!values.role) {
        errors.role = 'Role is required';
      }

      if (!values.meal.value && values.meal.enabled) {
        errors.meal = 'Meal time is required';
      }
      if (!values.weekHours.value && values.weekHours.enabled) {
        errors.weekHours = 'Week Hours is required';
      }
      if (!values.dayHours.value && values.dayHours.enabled) {
        errors.dayHours = 'Day Hours is required';
      }
      if(values.dayHours.enabled && values.weekHours.enabled && values.dayHours.value && values.weekHours.value){
        if(parseFloat(values.dayHours.value) > parseFloat(values.weekHours.value)){
          errors.weekHours = 'Week hours should be greater than or equal to day hours'
        }
      }
    }
    if (values.workingHoursEnabled == true) {
      Object.keys(workingDays).forEach(day => {
        if(values?.[day] && Object.keys(values[day]).length > 0){
          const slots = values?.[day]?.slots || [];
          // Validate each slot
          slots && slots.length >0 && slots.forEach((slot, index) => {
            // Check if start is before end
            if (!isValidSlot(slot.start, slot.end)) {
              errors[`${day}${index}start`] = "start time should be less than end time";
            }
          });

          const overlapErrors = findOverlappingSlots(slots);
          if(overlapErrors && overlapErrors.length>0){
            overlapErrors.forEach(item => {
              errors[`${day}${item.slotIndex}start`] = item.message;
            })
          }
          //  console.log("errors", overlapErrors);
        }
      })
    }
    console.log("errors", errors);
    setFormErrors(errors)
    let isValid = !Object.keys(errors).length > 0;
    let isFormChanged = !_.isEqual(formValues, initialFormValues);
    console.log("isFormChanged", isFormChanged)
    setDisableSave(!isValid || !isFormChanged);
    return isValid && isFormChanged
  }

  const handleCloseSnack = () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  //Adding new day in workerschedule
  const addDay = (Day) => {
    let slots = { [Day]: { slots: [{ start: startTime, end: endTime }] } };
  //  const updatedworkersSchedule = { ...workersSchedule, ...slots };
    setFormValues(prevState => ({...prevState, ...slots}));
  };

  //Remove a day in workerschedule
  const removeDay = (Day) => {
    setFormValues((prevState) => {
      const newState = { ...prevState }; 
      if (newState.hasOwnProperty(Day)) {
        delete newState[Day];  // Remove the property
      }
      console.log("removeDay", newState);
      return newState; // Return the updated state
    });
  };

  //Adds additional hour in timeslot
  const addHour = (Day, index) => {
    let time = { start: startTime, end: endTime };
    let slotName = index + 1;
    if (slotName < 8) {
      setFormValues(prevState => ({
        ...prevState,
        [Day]: {...prevState[Day], slots: [...prevState[Day].slots, time]}
      }))
    }
  };

  //Remove additional hour in timeslot
  const removeHour = (Day, index) => {
    return setFormValues(prevState =>{
      let Slots = Object.values(prevState[Day].slots);
      Slots.splice(index, 1);
    return  {
      ...prevState,
      [Day]: { ...prevState[Day], slots: Slots }
    }
    });
  };

   //Copy times to all days
   const copyTime = (day) => {
    let timeslots = formValues[day].slots;
    Object.keys(workingDays).map((D) => {
      if (workingDays[D]) {
        setFormValues((prevState) => ({
          ...prevState,
          [D]: { ...prevState[D], slots: timeslots }
        }));
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const data = {...formValues};
      const isValidForm = validate(data);
      if(!isValidForm){
        return ;
      }

      if(!user.workerId && !workerDocument && !workerDocument.workerId){
        return ;
      }
      const actionTS = new Date().toISOString(); 
      const timeRoleDoc = {
        isActive: data.isActive ? true : false,
        activityFamilyId: 'timeRole',
        role: data.role || "",
        isScannerOnly: data.isScannerOnly ? true: false,
        actionBy: user.workerId,
        actionTS: actionTS
      }
      let shouldUpdateWorker = false;
      const workerDoc = {
        actionBy: user.workerId,
        actionTS: actionTS,
        actionType: EDIT,
        workerId: workerDocument.workerId
      }
      const approverFlag = data.role !== "Worker";
      if(approverFlag !== workerDocument.isApprover){
        shouldUpdateWorker = true;
        workerDoc.isApprover = approverFlag;
      }

      const workerScheduleDoc = {
        actionBy: user.workerId,
        actionTS: actionTS,
        workingHoursEnabled: data.workingHoursEnabled? true : false,
        dayHours: data.dayHours,
        weekHours: data.weekHours,
        meal: data.meal,
      }
      Object.keys(workingDays).forEach(day => {
        if(data[day] && Object.keys(data[day]).length > 0){
          workerScheduleDoc[day] = {...data[day]};
        }
      })

      const response = await dispatch(updateIMTimeAccess(timeRoleDoc, workerScheduleDoc, workerDoc, shouldUpdateWorker));
      if(response && response.success){
        setSnackControl({
          open: true,
          message: "IMTIime Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "IMTIime Access update failed.",
          severity: 'error'
        })
      }
    }catch(error){
      console.log("handle IMTIme submit", error);
      setSnackControl({
        open: true,
        message: error,
        severity: 'error'
      })
    }
  }


  return (
    <>
      <Box>
        <form action="" id="formData">
         <Snack 
            openSnack={snackControl?.open} 
            severity={snackControl?.severity} 
            message={snackControl?.message} 
            handleCloseSnack={handleCloseSnack}>
          </Snack>
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)' }}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                IM Time
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container>
                  <Grid item sm={12} md={12} lg={4} marginBottom={4}>
                    <Grid
                      container
                      columnSpacing={3}
                      marginBottom={3}
                      alignItems="center"
                    >
                      <Grid item xs={1.5} marginLeft={2}>
                        <Typography sx={{ fontSize: "18px" }}>
                          Enable
                        </Typography>
                      </Grid>
                      <Grid item md={12} lg={5}>
                        <Switch 
                           inputProps={{ 'aria-label': 'Switch demo' }}
                           checked={formValues?.isActive}
                           onChange={(e) => {
                             let checked = e.target.checked;
                             setFormValues(prevState => ({ ...prevState, isActive: checked }));
                           }}
                           disabled={readOnly}
                        />
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={5}>
                      <Grid item xs={5.5} marginLeft={2}>
                        <Autocomplete
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Select Role"
                              error={formErrors?.role}
                              helperText={formErrors?.role}
                            />
                          )}
                          id="role"
                          name="role"
                          size="small"
                          disablePortal
                          options={roleoptions}
                          disabled = {!formValues?.isActive || readOnly}
                          onChange={(e, value) => {
                            console.log("isScannerOnly", value, formValues)
                            setFormValues(prevState => ({
                              ...prevState,
                              role: value? value : "",
                              isScannerOnly: value === "Worker" && prevState?.isScannerOnly ? true : false
                            }))
                          }}
                          value = {formValues?.role}
                          readOnly={readOnly}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <Checkbox
                          name="isScannerOnly"
                          id="isScannerOnly"
                          inputProps={{
                            "aria-label": "controlled",
                            shrink: true,
                            readOnly: readOnly
                          }}
                          checked = {formValues?.isScannerOnly}
                          disabled = {!formValues?.isActive || formValues?.role !== "Worker" || readOnly}
                          onChange={e => {
                            if(readOnly){
                              return;
                            }
                            else{
                              setFormValues(prevState => ({...prevState, isScannerOnly: e.target.checked}))
                            }
                          }}
                        />
                        Mobile Only
                      </Grid>
                    </Grid>
                    <Grid container marginTop={4}>
                      <Grid item xs={6} alignItems="center" marginLeft={2}>
                        <Checkbox 
                          disabled={!formValues.isActive || readOnly}
                          checked={formValues?.meal?.enabled ?? false}
                          onChange={(event) => {
                            let checked = event.target.checked;
                            if(readOnly) {
                              return;
                            }
                            else{
                              setFormValues(prevState => ({ ...prevState, 
                                meal: { ...(prevState.meal || {}), enabled: checked, 
                                value: prevState?.meal?.value || mealOptions[0] } }));
                              }}
                            }
                          inputProps={{ 'aria-label': 'controlled', readOnly: readOnly }}
                        />
                        Meal
                      </Grid>
                      <Grid item xs={4} style={{ display: formValues?.meal?.enabled ? '' : 'none' }}>
                        <Autocomplete
                          disabled={!formValues.isActive || readOnly}
                          disablePortal
                          renderInput={(params) => (
                            <TextField 
                            {...params} 
                            required={true}
                            value="30 min"
                            error={formErrors?.meal}
                            helperText={formErrors?.meal} 
                            />
                          )}
                          options={mealOptions}
                          id="mealTime"
                          name="meal"
                          size="small"
                          value={formValues?.meal?.value}
                          onChange={(event, value) => {
                          setFormValues(prevState => (
                              { ...prevState,
                               meal: { ...(prevState.meal || {}), value: value ? value : '' } }));
                          }}
                          readOnly={readOnly}
                        />
                      </Grid>
                    </Grid>
                    <Grid container marginTop={4}>
                      <Grid item xs={6} alignItems="center" marginLeft={2}>
                        <Checkbox 
                           disabled={!formValues?.isActive || readOnly}
                           checked={formValues?.weekHours?.enabled}
                           onChange={(event) => {
                             let checked = event.target.checked;
                             if(readOnly) {
                              return;
                             }
                             else{
                               setFormValues(prevState => ({ ...formValues, 
                                weekHours: { ...(prevState?.weekHours || {}), enabled: checked } }));
                              }}
                            }
                           inputProps={{ 'aria-label': 'controlled', readOnly: readOnly }}
                        />
                        Hours Per Week
                      </Grid>
                      <Grid item xs={4} style={{ display: formValues?.weekHours?.enabled ? '' : 'none' }}>
                        <Autocomplete
                          disabled={!formValues?.isActive || readOnly}
                          disablePortal
                          renderInput={(params) => (
                            <TextField
                              required={true}
                              {...params}
                              value="40 Hours"
                              error={formErrors?.weekHours}
                              helperText={formErrors?.weekHours}
                            />
                          )}
                          id="weekHours"
                          name="weekHours"
                          options={formValues?.dayHours?.enabled ? weekHoursOptions.filter(val => parseFloat(val) >= parseFloat(formValues?.dayHours?.value || 0) ) : weekHoursOptions}
                          size="small"
                          value={formValues?.weekHours?.value}
                          onChange={(event, value) => {
                            setFormValues(prevState => (
                              { ...prevState,
                                weekHours: { ...(prevState.weekHours || {}), value: value ? value : '' } }));
                          }}
                          readOnly={readOnly}
                        />
                      </Grid>
                    </Grid>
                    <Grid container marginTop={4}>
                      <Grid item xs={6} alignItems="center" marginLeft={2}>
                        <Checkbox 
                         disabled={!formValues?.isActive || readOnly}
                         checked={formValues?.dayHours?.enabled}
                         onChange={(event) => {
                            let checked = event.target.checked;
                            if(readOnly){
                              return;
                            }
                            else{

                              setFormValues(prevState => ({ ...formValues, 
                                dayHours: { ...(prevState?.dayHours || {}), enabled: checked }, 
                                weekHours: {...(prevState?.weekHours || {}), 
                                value: parseFloat(prevState?.dayHours?.value || 0) >= parseFloat(prevState?.weekHours?.value || 0) ? Math.ceil(parseFloat(prevState?.dayHours?.value || 0))+' Hours' : prevState?.weekHours?.value} }));
                              }}
                            }
                         inputProps={{ 'aria-label': 'controlled', readOnly: readOnly }}
                        />
                        Hours Per Day
                      </Grid>
                      <Grid item xs={4} style={{ display: formValues?.dayHours?.enabled ? '' : 'none' }}>
                        <Autocomplete
                          disabled={!formValues?.isActive || readOnly}
                          disablePortal
                          renderInput={(params) => (
                            <TextField
                              required={true}
                              {...params}
                              value="8 Hours"
                              error={formErrors?.dayHours}
                              helperText={formErrors?.dayHours}
                            />
                          )}
                          id="dayHours"
                          name="dayHours"
                          options={dayHoursOptions}
                          size="small"
                          value={formValues?.dayHours?.value}
                          onChange={(event, value) => {
                            setFormValues(prevState => (
                              { ...prevState,
                                dayHours: { ...(prevState.dayHours || {}), value: value ? value : '' },
                                weekHours: {...(prevState?.weekHours || {}), 
                                value: parseFloat(value || 0) >= parseFloat(prevState?.weekHours?.value || 0) ? Math.ceil(parseFloat(value || 0))+' Hours' : prevState?.weekHours?.value || 0} }));
                          }}
                          readOnly={readOnly}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={12} md={12} lg={8}>
                    <Grid
                      container
                      columnSpacing={3}
                      marginBottom={3}
                      alignItems="center"
                    >
                      <Grid item xs={0.8} alignItems="center">
                        <Checkbox 
                          disabled={!formValues.isActive || readOnly}
                          checked={formValues?.workingHoursEnabled}
                          onChange={(event) => {
                            let checked = event.target.checked;
                            if(readOnly){
                              return;
                            }
                            else{
                              setFormValues(prevState => ({ ...prevState, workingHoursEnabled: checked }));
                            }}
                          }
                          inputProps={{ 'aria-label': 'controlled', readOnly: readOnly }}
                        />
                      </Grid>
                      <Grid item xs={5} alignItems="center">
                        <Typography sx={{ fontSize: "18px" }}>
                          Enable Working Hours
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={5} style={{ display: !formValues?.workingHoursEnabled ? 'none' : '' }}>
                      <Grid item xs={10}>
                        {Object.keys(workingDays).map((Day) => {
                          return (
                            <Checkbox
                              inputProps={{readOnly: readOnly}}
                              key={Day}
                              checked={workingDays[Day] ? true : false}
                              icon={
                                <Icon
                                  sx={{
                                    backgroundColor: "rgba(60,64,67,.08)",
                                    padding: "5px",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <Typography variant="body1">
                                    {Day.charAt(0)}
                                  </Typography>
                                </Icon>
                              }
                              checkedIcon={
                                <Icon
                                  sx={{
                                    backgroundColor: "#1B75BC",
                                    padding: "5px",
                                    borderRadius: "50%",
                                    color: "#fff",
                                  }}
                                >
                                  <Typography variant="body1">
                                    {Day.charAt(0)}
                                  </Typography>
                                </Icon>
                              }
                              onChange={(e) => {
                                let checked = e.target.checked;
                                if(readOnly){
                                  return;
                                }
                                else{
                                  setworkingDays(prevState => ({
                                    ...prevState,
                                    [Day]: checked,
                                  }));
                                }
                                checked ? addDay(Day) : removeDay(Day);
                              }}
                              disabled={!formValues?.isActive || readOnly}
                            ></Checkbox>
                          );
                        })}
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={5} style={{ display: !formValues?.workingHoursEnabled ? 'none' : '' }}>
                      <Grid item>
                        {Object.keys(workingDays).filter(day => workingDays[day]).map((Day, dayIndex) => {
                          return  Object.keys(formValues?.[Day]?.slots || {}).map((slot, index) => {
                            let lastItem = Object.keys(formValues?.[Day]?.slots || {}).pop();
                            let firstItem = 0;
                            let slotName = Day + slot;
                            let startID = slotName + 'start';
                            let endID = slotName + 'end';
                            return  (
                            <Grid
                              container
                              marginTop={3}
                              columnSpacing={5}
                              alignItems="center"
                            >
                              <Grid xs={1} item marginLeft={2} marginRight={5} >
                                <Typography variant="body2" sx={{ display: index === firstItem ? '' : 'none' }}>{Day}</Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <TimePicker
                                    id={startID}
                                    minutesStep={5}
                                    input
                                    slotProps={{ 
                                      textField: { 
                                        size: "small", 
                                        error: formErrors?.[`${Day}${index}start`], 
                                        helperText: formErrors?.[`${Day}${index}start`]
                                      } }}
                                    label="Start Time"
                                    value={dayjs(formValues?.[Day]?.slots[index]?.start, 'hh:mma')}
                                    onChange={(event) => {
                                      let value = event.format('hh:mma').replace(/^12(?=:)/, '00');
                                      setFormValues(prevState => {
                                        const newState = { ...prevState };
                                        newState[Day].slots[index].start = value;
                                        return {
                                          ...newState
                                        }
                                      });
                                    }}
                                    disabled={!formValues?.isActive || readOnly}
                                    readOnly={readOnly}
                                  />
                                </LocalizationProvider>
                              </Grid>
                              <Grid item xs={0.5}>
                                <Typography variant="body2">to</Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <TimePicker
                                    id={endID}
                                    minutesStep={5}
                                    slotProps={{ 
                                      textField: { 
                                        size: "small", 
                                        error: formErrors?.[`${Day}${index}end`], 
                                        helperText: formErrors?.[`${Day}${index}end`]
                                      } }}
                                    label="End Time"
                                    value={dayjs(formValues?.[Day]?.slots[index]?.end, 'hh:mma')}
                                    onChange={(event) => {
                                      let value = event.format('hh:mma').replace(/^12(?=:)/, '00');
                                      setFormValues(prevState => {
                                        const newState = { ...prevState };
                                        newState[Day].slots[index].end = value;
                                        return {
                                          ...newState
                                        }
                                      });
                                    }}
                                    disabled={!formValues?.isActive || readOnly}
                                    readOnly={readOnly}
                                  />
                                </LocalizationProvider>
                              </Grid>
                              <Grid item xs={0.5} textAlign={"center"}>
                                <Tooltip title={readOnly ? "" : "Add Additional Slots"}>
                                  <IconButton color="primary"
                                    onClick={() => {
                                      if(readOnly){
                                        return;
                                      }
                                      else{
                                        addHour(Day, index);
                                        // setDisableSubmit(false);
                                      }
                                    }}
                                    disabled={!formValues?.isActive || readOnly}>
                                    <AddCircleOutlineRounded
                                      id={Day}
                                      fontSize="small"
                                      sx={{ cursor: 'pointer', display: index == lastItem ? '' : 'none' }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={0.5} textAlign={"center"}
                              sx={{ cursor: "pointer", display: index !== firstItem ? '' : 'none' }}>
                                <Tooltip title={readOnly ? "" : "Remove Slot"}>
                                  <IconButton color="primary"
                                    onClick={() => {
                                      if(readOnly){
                                        return;
                                      }
                                      else{
                                        removeHour(Day, index);
                                        // setDisableSubmit(false);
                                      }
                                    }}
                                    disabled={!formValues?.isActive || readOnly}>
                                    <RemoveCircleOutlineRounded
                                      fontSize="small"
                                      sx={{ cursor: "pointer" }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={0.5} sx={{ cursor: "pointer", display: dayIndex === firstItem && index === firstItem ? '' : 'none' }}>
                                <Tooltip title={readOnly ? "" : "Copy times to all"}>
                                  <IconButton color="primary" 
                                   onClick={() => {
                                    if(readOnly){
                                      return;
                                    }
                                    else{
                                      copyTime(Day);
                                    }
                                  }}
                                  disabled={!formValues?.isActive || readOnly}>
                                    <ContentCopyOutlined />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          )});
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 35, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      onClick={handleSubmit}
                      disabled={disableSave}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};
export default React.memo(IMTime);
